// extracted by mini-css-extract-plugin
module.exports = {"responseText":"ResultTransactionsModal_responseText__1YkY_","bodyText":"ResultTransactionsModal_bodyText__19KWa"};